module.exports = __webpack_public_path__ + "697574b47bcfdd2c45e3e63c7380dd67.woff";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold.woff
// module id = 1548
// module chunks = 0